var styles = {"list":"styles_list__BLaV5","item":"styles_item__3TEb1","label":"styles_label__XkNTy","removeButton":"styles_remove-button__Y3k4y"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
